import { Box } from '@mui/material';
import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useParams } from 'react-router-dom';

import { getSelectedPropertyId } from 'entities/Property/model/selectors/PropertySelectors';
import { propertyActions } from 'entities/Property/model/slices/PropertySlice';
import { getPropertyItem } from 'features/fetchPropertyById/model/selectors/fetchPropertyByIdSelectors';
import { fetchPropertyById } from 'features/fetchPropertyById/model/services/fetchPropertyById/fetchPropertyById';
import { useAppDispatch } from 'shared/lib/hooks/useAppDispatch';

export const PropertiesItem = () => {
    const dispatch = useAppDispatch();
    const params = useParams();

    const selectedPropertyId = useSelector(getSelectedPropertyId);
    const propertyItem = useSelector(getPropertyItem);

    const onGetProperty = useCallback(
        async (selectedPropertyId: string) => {
            await dispatch(fetchPropertyById(selectedPropertyId));
        },
        [dispatch],
    );

    useEffect(() => {
        if (params?.propertyId) {
            dispatch(propertyActions.selectProperty(params.propertyId));
            onGetProperty(params.propertyId);
        }
    }, [onGetProperty, params?.propertyId, dispatch]);

    return (
        <>
            {selectedPropertyId && propertyItem && (
                <Box display="flex" flexDirection="column" flex={1}>
                    <Outlet />
                </Box>
            )}
        </>
    );
};
